import { Injectable, ElementRef  } from '@angular/core';
import { getFirebaseBackend } from '../../firebaseBackend/firestoreUtils';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LogsService } from './logs.service';
import jwt_decode from "jwt-decode";

@Injectable({
  providedIn: 'root'
})
export class IntegrationsService {

  private moduleName = 'integrations';
  private modalTemplates: { [key: string]: ElementRef<any> } = {};

  constructor(private logsService: LogsService, private modalService: NgbModal) { }
  
  registerTemplate(id: string, template: ElementRef<any>) {
    this.modalTemplates[id] = template;
  }

  openModal(id: string): Promise<any> {
    const template = this.modalTemplates[id];
    if (template) {
      return this.modalService.open(template, { centered: true, windowClass: 'modal-holder' , size: "md" ,backdrop: 'static', keyboard: false  }).result;
    } else {
      console.warn(`Modal with ID '${id}' not found`);
      return Promise.resolve();
    }
  }
  /**
  * create integrationData by project ID
  */
  createIntegration(integrationData: any, PID: string) {
    const integrationsCollictionPath = `projects/${PID}/integrations`;
    return getFirebaseBackend().createNewDocumentByCollectionPath(integrationsCollictionPath, integrationData).then((integration: any) => {
      this.logsService.sendLogRequest(PID,{
        log_generated_ts: new Date().getTime(),
        module: this.moduleName,
        action: "shopify_integration_created",
        data: JSON.stringify({
          integration_id: integration.id,
          integration_name: integrationData.name,
          integration_domain: integrationData.domain
        })
      })
      return integration;
    })
  }

  checkDomainExistence(domain:string){
    return getFirebaseBackend().makeCollectionGroupQuery('integrations','domain',domain).then((existIntegration)=>{
      return existIntegration? true:false;
    })
    
  }

  checkCustomDomainExistence(customDomain:string){
    return getFirebaseBackend().makeCollectionGroupArrayContainQuery('integrations','custom_domains',customDomain).then((existIntegration)=>{
      return existIntegration? true:false;
    })
  }

  getIntegrationDataWithId(PID:string,iid:string){
    const integrationsDocumentPath = `projects/${PID}/integrations/${iid}`;
    return getFirebaseBackend().getDocumentByDocPath(integrationsDocumentPath).then((integration)=>{
      return integration;
    })
  }

  getIntegrationDataWithIdListener(PID:string,iid:string,cb){
    const integrationsDocumentPath = `projects/${PID}/integrations/${iid}`;
    return getFirebaseBackend().getDocumentWithListener(integrationsDocumentPath,(res)=>{
        cb(res)
    })
  }

  getIntegrations(PID:string,cb){
    const integrationsCollictionPath = `projects/${PID}/integrations`;
    return getFirebaseBackend().getCollicationUpdatesWithListener(integrationsCollictionPath,'created_at','desc',(res)=>{
      cb(res);
    })
  }

  getShopifyIntegrations(PID:string){
    const integrationsCollictionPath = `projects/${PID}/integrations`;
    return getFirebaseBackend().getDocumentsWithSpecificProperty(integrationsCollictionPath,'type','shopify').then((integration)=>{
      return integration;
    })
  }

  getProjectIntegrations(PID:string){
    const integrationsCollictionPath = `projects/${PID}/integrations`;
    return getFirebaseBackend().getCollectionDoucmentsByCollectionPath(integrationsCollictionPath).then((integrations)=>{
      return integrations;
    })
  }

  editIntegration(PID:string,iid:string,editedData:any){
    const integrationsDocumentPath = `projects/${PID}/integrations/${iid}`;
    return getFirebaseBackend().editDocumentByDocPath(integrationsDocumentPath,editedData).then((integration)=>{
      return integration;
    })
  }

  parseDomainFromSession(token:string){
    const decoded:any = jwt_decode(token);
    return decoded?.session;
  }

  addIntegrationWidget(pid:string,iid:string,widget:any){
    const shopifyIntegrationWidgetsCollection = `projects/${pid}/integrations/${iid}/recommendation_widgets`;
    return getFirebaseBackend().createNewDocumentByCollectionPath(shopifyIntegrationWidgetsCollection,widget).then((widget)=>{
      return widget;
    })
  }

  getShopifyIntegrationWidgets(pid:string,iid:string){
    const shopifyIntegrationWidgetsCollection = `projects/${pid}/integrations/${iid}/recommendation_widgets`;
    return getFirebaseBackend().getCollectionDoucmentsByCollectionPath(shopifyIntegrationWidgetsCollection).then((widgets)=>{
      return widgets;
    })
  }

  /**
  * get the recommendation widgets of every store of the project, each widget carries its store name
  */
  getProjectRecommendationWidgets(pid:string){
    return this.getProjectIntegrations(pid).then((integrations:any)=>{
      return Promise.all(integrations.map((integration:any)=>{
        return this.getShopifyIntegrationWidgets(pid,integration.id).then((widgets:any)=>{
          return (widgets||[]).map((widget:any)=>({
            ...widget,
            store_id: widget.store_id || integration.id,
            store_name: integration.name
          }));
        })
      })).then((storesWidgets:any[])=>{
        return storesWidgets
          .reduce((allWidgets,storeWidgets)=> allWidgets.concat(storeWidgets),[])
          .sort((a:any,b:any)=> (b.created_at?.seconds||0) - (a.created_at?.seconds||0));
      })
    })
  }

  getIntegrationWidget(pid:string,iid:string,wid:string){
    const widgetDocumentPath = `projects/${pid}/integrations/${iid}/recommendation_widgets/${wid}`;
    return getFirebaseBackend().getDocumentByDocPath(widgetDocumentPath).then((widget:any)=>{
      return widget;
    })
  }

  updateIntegrationWidget(pid:string,iid:string,wid:string,widget:any){
    const shopifyWidgetDocumentPath = `projects/${pid}/integrations/${iid}/recommendation_widgets/${wid}`;
    return getFirebaseBackend().editDocumentByDocPath(shopifyWidgetDocumentPath,widget).then((widget:any)=>{
      return widget;
    })
  }

  deleteShopifyIntegrationWidget(pid:string,iid:string,wid:string){
    const shopifyWidgetDocumentPath = `projects/${pid}/integrations/${iid}/recommendation_widgets/${wid}`;
    return getFirebaseBackend().deleteDocumentByDocPath(shopifyWidgetDocumentPath).then((widget:any)=>{
      console.log(wid);
      return widget;
    })
  }

  deleteIntegration(pid:string, iid:string){
    const integrationDocumentPath = `projects/${pid}/integrations/${iid}`;
    return getFirebaseBackend().deleteDocumentByDocPath(integrationDocumentPath).then((integration:any)=>{
      return integration;
    })
  }

  checkProjectHasIntegration(pid:string){
    const integrationsCollictionPath = `projects/${pid}/integrations`;
    return getFirebaseBackend().checkDocsExistanceInCollection(integrationsCollictionPath).then((hasStores:boolean)=>{
      return hasStores;
    })
  }

  checkProjectHasIntegrationWithListener(pid:string, cb){
    const integrationsCollictionPath = `projects/${pid}/integrations`;
    return getFirebaseBackend().checkDocsExistanceInCollectionWithListener(integrationsCollictionPath,(hasStores:boolean)=>{
      cb(hasStores);
    })
  }

  getStoreTrackers(projectId:string,integrationId:string){
    const trackersCollectionPath = `projects/${projectId}/trackers`;
    return getFirebaseBackend().getDocumentsWithSpecificProperty(trackersCollectionPath, 'store_id', integrationId).then((trackers:any)=>{
      const trackersTablesIds = []
      trackers.forEach((tracker:any) => {
        trackersTablesIds.push(`${projectId}_${tracker.id}`);
      });
      return trackersTablesIds;
    })
  }

  getStoreProductsConnectors(projectId:string,integrationId:string){
    const productsConnectorsCollectionPath = `projects/${projectId}/products_connectors`;
    return getFirebaseBackend().getDocumentsWithSpecificProperty(productsConnectorsCollectionPath, 'store_id', integrationId).then((connectors:any)=>{
      const connectorsTablesIds = []
      connectors.forEach((connector:any) => {
        connectorsTablesIds.push(`${projectId}_${connector.id}`);
      });
      return connectorsTablesIds;
    })
  }
}
